<template>
  <div class="div-container">
    <validation-observer ref="refFormObserver">
      <b-form>
        <!-- Master Tenant -->
        <validation-provider
          #default="validationContext"
          name="Master Tenant"
          rules="required"
        >
          <b-form-group
            class="text-capitalize"
            :label="$tc('master_tenants.title', 2)"
            label-for="id_master_tenant"
            :state="getValidationState(validationContext)"
          >
            <v-select
              v-model="itemData.master_tenant"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="masterTenantOptions"
              :clearable="false"
              :reduce="option => option.value"
              input-id="id_master_tenant"
              multiple
              :disabled="masterTenantDisabled || isClone"
              data-cy="automatest-wizard-master-tenant-select"
              @input="onMasterTenantInput"
            />

            <b-form-invalid-feedback
              :state="getValidationState(validationContext)"
            >
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <!-- Tenant -->
        <validation-provider
          #default="validationContext"
          name="Tenant"
          rules="required"
        >
          <b-form-group
            class="text-capitalize"
            :label="$tc('tenants.title', 2)"
            label-for="id_tenant"
            :state="getValidationState(validationContext)"
          >
            <v-select
              v-model="itemData.tenant"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="tenantOptions"
              :clearable="false"
              :reduce="option => option.value"
              input-id="id_tenant"
              multiple
              :disabled="isClone"
              data-cy="automatest-wizard-tenant-select"
              @input="onTenantInput"
            />

            <b-form-invalid-feedback
              :state="getValidationState(validationContext)"
            >
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <!-- Tipos de alarma -->
        <multiple-alarms-select
          :itemData="{ type_alarm: itemData.type_alarm ? itemData.type_alarm : [] }"
          :options="typeAlarmOptions"
          @update:itemData="$emit('update:itemData', $event)"
        />

      </b-form>
    </validation-observer>

    <div
      v-if="
        userGroup &&
        Array.isArray(itemData.groups) &&
        itemData.groups.length
      "
      class="belongGroup"
    >
      <span
        class="belongGroup-text"
        @click="
          $can('update', 'Group')
            ? openGroup(itemData.groups[0].id)
            : null
        "
      >
        {{
          $t("users.belogs_user") +
          itemData.groups[0].name
        }}
      </span>
    </div>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInvalidFeedback,
  BFormCheckbox,
} from "bootstrap-vue";

import {
  ref,
  computed,
  watch,
  getCurrentInstance
} from "@vue/composition-api";

import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate";

import formValidation from "@core/comp-functions/forms/form-validation";
import vSelect from "vue-select";

import {
  required,
  alphaNum,
  email,
  positive,
  required_if,
} from "@validations";

import store from "@/store";

import MultipleAlarmsSelect from "@/components/Alarm/MultipleAlarmsSelect";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormGroup,
    BFormInvalidFeedback,
    BFormCheckbox,
    vSelect,
    MultipleAlarmsSelect,
  },

  props: {
    propItemData: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    masterTenantOptions: {
      type: Array,
      required: true,
    },

    typeAlarmOptions: {
      type: Array,
      required: true,
    },

    isClone: {
      type: Boolean,
      required: false,
      default: false,
    },

    userGroup: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      required,
      alphaNum,
      email,
      positive,
      required_if,
    };
  },

  setup(props, { emit }) {
    const vm = getCurrentInstance();
    const proxy = vm.root.proxy;
    const userData = JSON.parse(
      localStorage.getItem("userData") || "{}"
    );

    const masterTenantDisabled = ref(false);

    const {
      refFormObserver,
      getValidationState,
    } = formValidation();


    //we always need Id of arrays
    const normalizeItemData = value => {
      const source = value || {};

      return {
        ...source,

        master_tenant: Array.isArray(
          source.master_tenant
        )
          ? [...source.master_tenant]
          : [],

        tenant: Array.isArray(
          source.tenant
        )
          ? [...source.tenant]
          : [],

        type_alarm: Array.isArray(
          source.type_alarm
        )
          ? [...source.type_alarm]
          : [],

        groups: Array.isArray(
          source.groups
        )
          ? [...source.groups]
          : [],
      };
    };

    const itemData = ref(
      normalizeItemData(props.propItemData)
    );

    store
      .dispatch("master_tenant/getAll")
      .then(response => {
        const data =
          response?.data || [];

        if (
          data.length === 1 &&
          !userData.is_master_admin
        ) {
          const masterTenant =
            data[0];

          const masterTenantId =
            masterTenant.id;

          const alreadySelected =
            itemData.value.master_tenant.some(
              selectedId =>
                String(selectedId) ===
                String(masterTenantId)
            );

          if (!alreadySelected) {
            itemData.value.master_tenant = [
              masterTenantId,
            ];
          }

          masterTenantDisabled.value =
            true;

          emit("update:itemData", {
            master_tenant: [
              ...itemData.value.master_tenant,
            ],
          });
        }
      })
      .catch(error => {
        console.error(
          "Error cargando master tenants:",
          error
        );
      });


    store
      .dispatch("tenant/getAll")
      .catch(error => {
        console.error(
          "Error cargando tenants:",
          error
        );
      });


    const tenantOptions = computed(() => {
      const tenants =
        store.getters["tenant/getItems"] ||
        [];

      const selectedMasterTenants =
        Array.isArray(
          itemData.value.master_tenant
        )
          ? itemData.value.master_tenant
          : [];

      return tenants
        .filter(tenant =>
          selectedMasterTenants.some(
            masterTenantId =>
              String(masterTenantId) ===
              String(
                tenant.id_master_tenant
              )
          )
        )
        .map(tenant => ({
          ...tenant,

          value: tenant.id,

          label:
            tenant.name ||
            tenant.description ||
            `#${tenant.id}`,
        }));
    });


    const onMasterTenantInput = value => {
      const selectedValues =
        Array.isArray(value)
          ? [...value]
          : [];

      itemData.value.master_tenant =
        selectedValues;

      const validTenantIds = new Set(
        tenantOptions.value.map(option =>
          String(option.value)
        )
      );

      const filteredTenants =
        itemData.value.tenant.filter(
          tenantId =>
            validTenantIds.has(
              String(tenantId)
            )
        );

      itemData.value.tenant =
        filteredTenants;

      emit("update:itemData", {
        master_tenant: [
          ...selectedValues,
        ],

        tenant: [
          ...filteredTenants,
        ],
      });
    };

    const onTenantInput = value => {
      const selectedValues =
        Array.isArray(value)
          ? [...value]
          : [];

      itemData.value.tenant =
        selectedValues;

      emit("update:itemData", {
        tenant: [...selectedValues],
      });
    };

    const validateStep = () => {
      if (!refFormObserver.value) {
        return Promise.resolve(false);
      }

      return refFormObserver.value.validate();
    };

    const openGroup = groupId => {
      if (!groupId) {
        return;
      }

      const groupUrl =
        `${window.location.origin}/#/group?groupId=${groupId}`;

      window.open(groupUrl);
    };


    watch(
      () => props.propItemData,
      newValue => {
        itemData.value =
          normalizeItemData(newValue);
      },
      {
        deep: true,
      }
    );

    return {
      itemData,

      refFormObserver,
      getValidationState,

      masterTenantDisabled,
      tenantOptions,

      onMasterTenantInput,
      onTenantInput,

      validateStep,
      openGroup,
    };
  },
};
</script>

<style lang="scss">
.vs--disabled .vs__selected {
  background-color: #1b3d5e !important;
}


.type-alarm-option {
  display: flex;
  width: 100%;
  min-height: 28px;
  align-items: center;
  cursor: pointer;
}


.custom-option-checkbox {
  display: inline-flex;
  width: 17px;
  height: 17px;
  flex: 0 0 17px;
  align-items: center;
  justify-content: center;
  border: 1px solid #b9b9c3;
  border-radius: 3px;
  background-color: #fff;
  pointer-events: none;
}

.custom-option-checkbox-selected {
  color: #fff;
  border-color: #7367f0;
  background-color: #7367f0;
}

.vs__dropdown-option .type-alarm-option {
  width: 100%;
}
</style>
